import { Trans } from '@/plugins/Translation'


function load (component) {
    // '@' is aliased to src/components
    return () => import(/* webpackChunkName: "[request]" */ `@/${component}.vue`)
}


export default [
    {
        path: '/:lang',
        component: load('views/Lang'),
        beforeEnter: Trans.routeMiddleware,
        children: [
            {path: '/', name: 'home', component: load('views/Home')},
            {path: 'iframe/verifica-iscritti/:id', name: 'iframe-verificaiscritti', component: load('views/IframeVerificaIscritti'),sub:'event'},
            {path: 'iframe/race/:id', name: 'iframe-race', component: load('views/IframeRace'),sub:'event'},
            {path: 'race/:id', name: 'race', component: load('views/Race'),sub:'event'},
            {path: 'circuiti', name: 'circuiti', component: load('views/Circuiti')},
            {path: 'chi-siamo', name: 'chi-siamo', component: load('pages/ChiSiamo')},
            {path: 'servizi', name: 'servizi', component: load('pages/Servizi')},
            {path: 'contatti', name: 'contatti', component: load('pages/Contatti')},
            {path: 'lavora-con-noi', name: 'lavora-con-noi', component: load('pages/LavoraConNoi')},
            {path: 'privacy-policy', name: 'privacy-policy', component: load('pages/PrivacyPolicy')},
            {path: 'cookie-policy', name: 'cookie-policy', component: load('pages/CookiePolicy')},
            {path: '*', component: load('views/404')}
        ],
    },
    {
        // Redirect user to supported lang version.
        path: '*',
        redirect () {
            return Trans.getUserSupportedLang()
        }
    }
]
